export const getOrganizedUnitSaleOperationFilter = state => state.organizedUnitSaleOperation.filter
